// extracted by mini-css-extract-plugin
export var component = "Loading-module--component--tNzr5";
export var fullscreen = "Loading-module--fullscreen--hyfV2";
export var spinner = "Loading-module--spinner--cXwCI";